<template>
  <div>
    <list-header title="My Salons" />
    <pull-to-refresh :refreshFunction="getSalon">
      <div v-if="salon?.length !== 0">
        <div
          class="style-container style-container-shadow d-flex flex-row mt-4 scss-click-effect"
          v-for="branch in salon"
          :key="branch.id"
        >
          <!-- Product Image -->
          <div class="scss-bold my-auto style-salon">
            {{ branch.name }}
          </div>

          <!-- Content -->
          <div
            class="text-start p-3 d-flex flex-column style-content my-auto align-items-center"
          >
            <span
              class="scss-overflow-text-style style-branch-details"
              v-if="branch.cwaRegistered !== undefined"
              >CWA Registered:
              {{
                branch.cwaRegistered ? formatDate(branch.cwaRegistered) : "-"
              }}
              (Default)</span
            >
            <span class="scss-overflow-text-style style-branch-details"
              >CWA Status: {{ formatTicketStatus(branch.cwaStatus) }}
            </span>
            <span class="scss-overflow-text-style style-branch-details"
              >Last Visit:
              {{ formatDate(branch.lastVisit) }}
            </span>
          </div>
        </div>
      </div>
      <div v-else>
        <item-not-found message="No item found." />
      </div>
    </pull-to-refresh>
  </div>
</template>

<script>
import ListHeader from "@/components/ListHeader.vue";
import PullToRefresh from "@/components/PullToRefresh";
import ItemNotFound from "@/components/ItemNotFound.vue";
import { mapGetters, mapActions } from "vuex";
import { branchStatus } from "@/common/constant/BranchStatus";
import { convertDateFormat } from "@/common/helpers/DateTimeHelper";

export default {
  name: "MySalon",
  components: { ListHeader, PullToRefresh, ItemNotFound },
  computed: {
    ...mapGetters(["salon"]),
  },
  methods: {
    formatTicketStatus(status) {
      return branchStatus[status];
    },
    formatDate(dateTime) {
      return `${dateTime ? convertDateFormat(dateTime) : "-"}`;
    },
    ...mapActions(["getSalon"]),
  },
  created() {
    this.getSalon();
  },
};
</script>
<style lang="scss" scoped>
.style-container {
  width: 90%;
  margin: 0 auto 0 auto;
  height: fit-content;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  min-height: 130px;
  border-left: 1px solid $border-light-grey;
  border-top: 1px solid $border-light-grey;
}

.style-container-shadow {
  box-shadow: 1px 2px $border-light-grey;
}

.style-salon {
  width: 25%;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
}

.style-content {
  width: 75%;
  font-size: 12px;
  line-height: 24px;
}

.style-branch-details {
  width: 80%;
}
</style>
